import React, { useState, useEffect } from 'react';
import { Button } from '../../../components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../../components/ui/dialog';
import { Label } from '../../../components/ui/label';
import { Input } from '../../../components/ui/input';

interface SendReportEmailModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  projectNumber: string;
  title?: string;
  description?: string;
  initialEmail?: string;
  isSending?: boolean;
  submitLabel?: string;
  submittingLabel?: string;
  /** When true, email is fixed to the logged-in user (large selections). */
  emailReadOnly?: boolean;
  onSend: (emails: string[]) => void;
}

/**
 * Reusable modal to send a report email. Accepts comma-separated email addresses.
 * Parent should dispatch the appropriate send-email action with { projectNumber, emails } and pass cb/error to handle loading and close.
 */
export const SendReportEmailModal: React.FC<SendReportEmailModalProps> = ({
  open,
  onOpenChange,
  projectNumber,
  title = 'Send Email',
  description = 'Enter one or more email addresses. Separate multiple addresses with commas.',
  initialEmail = '',
  isSending = false,
  submitLabel = 'Send',
  submittingLabel = 'Sending...',
  emailReadOnly = false,
  onSend,
}) => {
  const [emailInput, setEmailInput] = useState('');

  useEffect(() => {
    if (open) {
      setEmailInput(initialEmail);
    } else {
      setEmailInput('');
    }
  }, [open, initialEmail]);

  const handleSubmit = () => {
    const emails = emailInput
      .split(/[,;\s]+/)
      .map((e) => e.trim())
      .filter(Boolean);
    if (emails.length === 0) return;
    onSend(emails);
  };

  const emails = emailInput
    .split(/[,;\s]+/)
    .map((e) => e.trim())
    .filter(Boolean);
  const canSubmit = emails.length > 0 && !isSending;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <p className="text-sm text-gray-600">{description}</p>
          <div className="space-y-2">
            {/* <Label htmlFor="send-report-emails">
              {emailReadOnly ? 'Notification email (your login)' : 'Email addresses'}
            </Label> */}
            {/* <Input
              id="send-report-emails"
              type="text"
              placeholder="e.g. user@example.com, other@example.com"
              value={emailInput}
              onChange={(e) => setEmailInput(e.target.value)}
              disabled={isSending || emailReadOnly}
              readOnly={emailReadOnly}
              className="w-full"
            /> */}
          </div>
          <div className="flex justify-end gap-2">
            <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isSending}>
              Cancel
            </Button>
            <Button onClick={handleSubmit} disabled={!canSubmit}>
              {isSending ? submittingLabel : submitLabel}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
